export enum BatchAgreement {
    'OFFICE' = 'BATCH_CONTROL-OFFICE',
    'DEPARTMENT' = 'BATCH_CONTROL-DEPARTMENT',
    'EFFECTIVE_DATE' = 'EFFECTIVE_DATE',
    'REC_STATUS' = 'BATCH_CONTROL-REC_STATUS',
    'PROFILE_CHANGE_STATUS' = 'BATCH_CONTROL-PROFILE_CHANGE_STATUS',
    'BTCH_CTRL_ID' = 'BATCH_CONTROL-BTCH_CTRL_ID',
    'CALCULATE_DBT_FEE_ON_S' = 'BATCH_CONTROL-CALCULATE_DBT_FEE_ON_S',
    'REPRESENTMENTS_UID' = 'BATCH_CONTROL-REPRESENTMENTS_UID',
    'ITEMIZED_POSTING' = 'BATCH_CONTROL-ITEMIZED_POSTING',
    'PERFORM_BALANCE_RESERVATION' = 'BATCH_CONTROL-PERFORM_BALANCE_RESERVATION',
    'SAMEDAY_PROCESSING_IND' = 'BATCH_CONTROL-SAMEDAY_PROCESSING_IND',
    'BATCH_LEVEL_PROCESSING' = 'BATCH_CONTROL-BATCH_LEVEL_PROCESSING',
    'USE_ALTRNT_MOP' = 'BATCH_CONTROL-USE_ALTRNT_MOP',
    'VD_ROLL_FWD' = 'BATCH_CONTROL-VD_ROLL_FWD',
    'FORCE_ITEMIZED_BTCH_SINGL_MSG' = 'BATCH_CONTROL-FORCE_ITEMIZED_BTCH_SINGL_MSG',
    'SWAP_ENABLED_BTCH' = 'BATCH_CONTROL-SWAP_ENABLED_BTCH',
    'ALLOW_MANUAL_CHANNEL' = 'BATCH_CONTROL-ALLOW_MANUAL_CHANNEL',
    'ALLOW_MANUAL_CHANNEL_DD' = 'BATCH_CONTROL-ALLOW_MANUAL_CHANNEL_DD',
    'ALLOW_MANUAL_CLEARING' = 'BATCH_CONTROL-ALLOW_MANUAL_CLEARING',
    'ALLOW_MANUAL_CLEARING_DD' = 'BATCH_CONTROL-ALLOW_MANUAL_CLEARING_DD',
    'RJCTD_CNCLD_ACC_NO' = 'BATCH_CONTROL-RJCTD_CNCLD_ACC_NO',
    'RJCTD_CNCLD_ACC_CCY' = 'BATCH_CONTROL-RJCTD_CNCLD_ACC_CCY',
    'RTRND_ACC_NO' = 'BATCH_CONTROL-RTRND_ACC_NO',
    'RTRND_ACC_CCY' = 'BATCH_CONTROL-RTRND_ACC_CCY',
    'END_PRE_PROC_STS_REPORT' = 'BATCH_CONTROL-END_PRE_PROC_STS_REPORT',
    'END_PROC_STS_REPORT' = 'BATCH_CONTROL-END_PROC_STS_REPORT',
    'PROCESS_STATUS_REPORT' = 'BATCH_CONTROL-PROCESS_STATUS_REPORT',
    'TIME_STAMP' = 'TIME_STAMP',
    'UID' = 'VIRTUAL-UID',
    'PROFILE_UPDATE_PK' = 'PROFILE_UPDATE_PK',
    'PU_TIME_STAMP' = 'PU_TIME_STAMP',
    'NOTE' = 'NOTE'
};
